<template>
  <scroll-animation-unit class="p-access u-fade">
    <GmapMap
      :center="{lat: Number(gmap.lat), lng: Number(gmap.lng)}" 
      :zoom="14" 
      :options="mapOptions"
      class="p-access__map">
      <GmapMarker
        :position="marker.position" 
        :icon="icon"
      /></GmapMap>
    <div class="p-access__link">
      <a v-if="isMobile" :href="`https://maps.google.co.jp/maps?q=${gmap.lat},${gmap.lng}&languege=en`" target="_blank" class="c-externalLink" data-type="map"><i class="icon-access"></i>Open the Google Map App</a>
      <a v-else :href="`https://maps.google.co.jp/maps?q=${gmap.lat},${gmap.lng}&languege=en`" target="_blank" class="c-externalLink" data-type="map"><i class="icon-access"></i>Open Google Map</a>
    </div>


    <div class="p-access__content">
      <dl v-if="hasDescription" class="p-access__description">
        <div class="p-access__row">
          <dt>Address</dt>
          <dd v-text="gmap.address"></dd>
        </div>
        <div v-if="url" class="p-access__row">
          <dt>URL</dt>
          <dd>
            <a :href="url" class="c-link" target="_blank">{{ url }}<i class="icon-external"></i></a>
          </dd>
        </div>
      </dl>

      <div v-for="item in destFrom" v-if="hasRoutes" class="p-access__from">
        <!-- TODO: dlをループ -->
        <dl class="p-access__route">
          <dt v-text="item.dest_from_title"></dt>
          <dd v-show="!isMobile">
            <ul class="p-access__links">
              <li v-for="link in item.dest_from_links">
                <a :href="link.link" target="_blank" class="c-link" v-text="link.text"></a>
              </li>
            </ul>
          </dd>
        </dl>
        <p v-html="item.dest_from_description"></p>
        <ul v-show="isMobile" class="p-access__links">
          <li v-for="link in item.dest_from_links">
            <a :href="link.link" target="_blank" class="c-link" v-text="link.text"></a>
          </li>
        </ul>
      </div>
    </div>
  </scroll-animation-unit>
</template>

<script>
  import marker from '~/assets/img/common/marker.png'
  /**
   * Share Partial
   */

  export default {
    name: 'cominca-access',
    props: {
      hasDescription: {
        type: Boolean,
        default: false
      },
      hasRoutes: {
        type: Boolean,
        default: false
      },
      gmap: {
        type: Object,
        required: true,
      },
      url: {
        type: String
      },
      destFrom: {
        type: Array,
      }
    },
    data() {
      return {
        mapOptions: {
          styles: [
            {
              "elementType": "geometry",
              "stylers": [
                { "saturation": -100 },
                { "lightness": 40 }
              ]
            },{
              "elementType": "labels",
              "stylers": [
                { "saturation": -50 }
              ]
            }
          ]
        },
        marker: {
          position: {
            lat: 0,
            lng: 0
          }
        }
      }
    },
    computed: {
      icon() {
        return marker
      },
      isMobile() {
        return this.$window.viewport === 'mobile'
      }
    },
    created() {
    },
    mounted() {
      this.marker.position.lat = Number(this.gmap.lat)
      this.marker.position.lng = Number(this.gmap.lng)
    },
    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// src/partial/cominca-access.vue